// const DISCOUNT_CODE = "CM30";

// async function renderSections() {
//   try {
//     await fetch(`/cart/checkout?discount=${DISCOUNT_CODE}&t=${Date.now()}`);
//   } catch (err) {
//     console.log(err);
//   }

//   try {
//     const response = await fetch("/?sections=main-cart-items,cart-drawer");

//     const data = await response.json();

//     const mainCartItemsSection = new DOMParser().parseFromString(
//       data["main-cart-items"],
//       "text/html"
//     );
//     const cartDrawerSection = new DOMParser().parseFromString(
//       data["cart-drawer"],
//       "text/html"
//     );

//     const mainCart = document.querySelector("cart-items");
//     const cartDrawer = document.querySelector("cart-drawer");

//     if (mainCart) {
//       mainCart.querySelector(".cart-items").innerHTML =
//         mainCartItemsSection.querySelector(".cart-items").innerHTML;

//       mainCart.querySelector(".cart__details .cart__summary").innerHTML =
//         mainCartItemsSection.querySelector(
//           ".cart__details .cart__summary"
//         ).innerHTML;

//       mainCart.querySelector(
//         ".cart__details .special-offer__section"
//       ).innerHTML = mainCartItemsSection.querySelector(
//         ".cart__details .special-offer__section"
//       ).innerHTML;

//       mainCart.querySelector(
//         ".cart__details .drawer-recommendations-section"
//       ).innerHTML = mainCartItemsSection.querySelector(
//         ".cart__details .drawer-recommendations-section"
//       ).innerHTML;

//       mainCart.querySelector(".cart__box-container").innerHTML =
//         mainCartItemsSection.querySelector(".cart__box-container").innerHTML;

//       mainCart.querySelector(".shipping-progress").innerHTML =
//         mainCartItemsSection.querySelector(".shipping-progress").innerHTML;

//       mainCart.querySelector(".progress-bar-container").innerHTML =
//         mainCartItemsSection.querySelector(".progress-bar-container").innerHTML;
//     }

//     cartDrawer.querySelector(".drawer__inner").innerHTML =
//       cartDrawerSection.querySelector("cart-drawer .drawer__inner").innerHTML;
//   } catch (err) {
//     console.log(err);
//   }

//   checkDiscountApplied();
//   setInitialRecommendations();
//   setBundleImage();
// }

// function setDiscountButton() {
//   const applyBtn = document.querySelectorAll(".cart__discount-apply");

//   applyBtn.forEach((btn) =>
//     btn.addEventListener("click", async () => {
//       btn.classList.add("loading");
//       try {
//         await fetch(`/discount/clear`);
//       } catch (err) {
//         console.log(err);
//       }

//       localStorage.setItem("DISCOUNT_CODE", DISCOUNT_CODE);
//       await renderSections(btn);
//       btn.classList.remove("loading");
//     })
//   );
// }

function checkDiscountApplied() {
  // setDiscountButton();
  // if (localStorage.getItem("DISCOUNT_CODE")) {
  //   const cartDiscount = document.querySelectorAll(".cart__discount");
  //   const cartPrice = document.querySelectorAll(".cart__price");
  //   cartDiscount.forEach((item) => item.classList.add("applied"));
  //   cartPrice.forEach((item) => item.classList.add("discount-applied"));
  // }
}

// window.addEventListener("DOMContentLoaded", function () {
//   checkDiscountApplied();

//   if (localStorage.getItem("DISCOUNT_CODE")) {
//     renderSections();
//   }
// });

// if (localStorage.getItem("DISCOUNT_CODE") === "BF25") {
//   localStorage.removeItem("DISCOUNT_CODE");
// }
